<template>
  <div class="partner-oidc-modal">
    <LoginRegisterModal ref="utdPartnerOidcModal"
                        :modal-props="modalProps"
                        :welcome-message="oidcPartnerDetails.modalConfig.welcomeMessage"
                        :message-array="oidcMessageArray"
                        :show-subscribe="isOidcSubscribe"
                        :show-register="isOidcRegister" />
    <BcdrNoticeModal ref="bcdrNoticeModal" 
                     feature-name="UpToDate Registration" 
                     @modal-closed="handleBcdrModalClosed" />
  </div>
</template>

<script setup>
import { ref, computed, watch, onBeforeUnmount, onMounted } from 'vue';
import { useStore } from 'vuex';
import { OIDC_WELCOME_MESSAGES } from '_acaSrc/utility/constants';
import LoginRegisterModal from './LoginRegisterModal.vue';
import BcdrNoticeModal from '../error/BcdrNoticeModal.vue';

const store = useStore();

const isTabletDevice = computed(() => store.getters['app/isTabletDevice']);
const isDesktopView = computed(() => store.getters['device/isDesktopView']);
const oidcPartnerModalButton = computed(() => store.getters['auth/oidcPartnerModalButton']);
const oidcPartnerDetails = computed(() => store.getters['auth/oidcPartnerDetails']);
const isDisasterRecovery = computed(() => store.getters['app/isDisasterRecovery']);
const isOidcUser = computed(() => store.getters['auth/isOidcUser']);
const oidcMessageArray = computed(() => isOidcRegister.value 
    ? OIDC_WELCOME_MESSAGES.REGISTER 
    : OIDC_WELCOME_MESSAGES.SUBSCRIBE);

const enableAutoFocus = computed(() => isDesktopView.value && !isTabletDevice.value);
const isOidcRegister = computed(() => oidcPartnerModalButton.value === 'register');
const isOidcSubscribe = computed(() => oidcPartnerModalButton.value === 'subscribe');

const utdPartnerOidcModal = ref(null);
const bcdrNoticeModal = ref(null);

const modalProps = {
    modalClasses: 'partnerOidcModal',
    autofocus: enableAutoFocus,
    closeOnOverlayClick: false,
    closeOnEscape: false,
    hideHeaderClose: true
};

const showModal = () => {
    if (isDisasterRecovery.value){
        openDisasterRecoveryModal();
    }
    else if (!oidcPartnerDetails.value.modalConfig.shown) {
        open();
    }
};

const open = () => {
    utdPartnerOidcModal.value.open();
};

const close = () => {
    utdPartnerOidcModal.value.close();
};

const openDisasterRecoveryModal = () => {
    bcdrNoticeModal.value.openModal();
};

const handleBcdrModalClosed = () => {
    store.getters['app/router'].url('/logout');
};

watch(isOidcUser, (newVal) => {
    if (newVal) {
        if (isOidcRegister.value) {
            store.dispatch('login/getRegistrationForm');
        }
        showModal();
    }
});

onMounted(() => {
    if (isOidcUser.value) {
        showModal();
    }
});

onBeforeUnmount(() => {
    close();
});
</script>